import classNames from "classnames";
import { AuthState } from "util/useAuth/types";
import { SimplePageLayout } from "../PageLayouts";
import { xPaddingClassName } from "./constants";

interface Props {
  children: React.ReactNode;
  auth: AuthState;
  inGameContextTitle: string | undefined;
  upgradeRedirectTo?: string;
}

export default function GameWrapper({
  children,
  auth,
  inGameContextTitle,
  upgradeRedirectTo,
}: Props) {
  return (
    <SimplePageLayout
      className={classNames(xPaddingClassName, "py-4 relative")}
      auth={auth}
      navbarProps={{
        inGame: true,
        inGameContextTitle,
        redirectTo: upgradeRedirectTo,
      }}
    >
      {children}
    </SimplePageLayout>
  );
}
